import React from 'react';
import Logo from "../../assets/img/Unauthorized1.png";
import { useLocation } from "react-router-dom";
import { App } from 'react-bootstrap-icons';
import { AppButton } from '@dcam/dcam_flhealth_component_library';

const Unauthorized = () => {
    const location = useLocation();
    const message = location.state?.message;

    return (
        <div className="row">
            <div className="col col-md-12 text-center">
                <div className="unauthorized">
                    <img src={Logo} alt={'Logo'} />

                    <h1 style={{ fontWeight: 'bold', color: '#3a3668' }}>
                        We are Sorry...
                    </h1>

                    <br />

                    <h4
  style={{ alignContent: 'center', color: '#636085' }}
  dangerouslySetInnerHTML={{
    __html: (message || "The page you're trying to access has restricted access.")
      .replace(/\n/g, "<br/>")
  }}
/>

                    {/* Show these ONLY when no custom message exists. */}
                    {!message && (
                        <>
                            <div>
                                <h4 style={{ alignContent: 'center', color: '#636085' }}>
                                    Please refer to your system administrator.
                                </h4>
                            </div>

                            <div>
                                <h4 style={{ alignContent: 'center', color: '#636085' }}>
                                    Try opening the page in a new Tab or Window.
                                </h4>
                            </div>
                            <div>
                            <AppButton
                            variant="primary"
                            onClick={() => {
                                window.location.href = "/";
                            }}
                            >
                            Refresh Page
                            </AppButton>
                                
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Unauthorized;